export default {
  'shared.password_required': '비밀번호 필요',
  'shared.password_required_desc': '이 프레젠테이션은 비밀번호로 보호되어 있습니다',
  'shared.enter_password': '비밀번호를 입력하세요',
  'shared.wrong_password': '비밀번호가 올바르지 않습니다',
  'shared.link_expired': '링크가 만료되었습니다',
  'shared.link_expired_desc': '이 공유 링크의 유효 기간이 지났습니다',
  'shared.not_found': '페이지를 찾을 수 없습니다',
  'shared.not_found_desc': '공유 링크가 유효하지 않거나 삭제되었습니다',
  'shared.error': '오류가 발생했습니다',
  'shared.error_desc': '잠시 후 다시 시도해주세요',
  'shared.loading_pdf': 'PDF를 불러오는 중...',
};
